/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earningsemptytitle2Inputs */

const en_earningsemptytitle2 = /** @type {(inputs: Earningsemptytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tickets yet`)
};

const de_earningsemptytitle2 = /** @type {(inputs: Earningsemptytitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine Tickets`)
};

/**
* | output |
* | --- |
* | "No tickets yet" |
*
* @param {Earningsemptytitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const earningsemptytitle2 = /** @type {((inputs?: Earningsemptytitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earningsemptytitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earningsemptytitle2(inputs)
	return de_earningsemptytitle2(inputs)
});
export { earningsemptytitle2 as "earningsEmptyTitle" }